export default __webpack_public_path__ + "static/media/main6.f36a6ba1.jpg";